import React, { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, MenuCLose } from './icons';
import { Drawer, Dropdown } from "antd";
import { Link as RouterLink } from "react-router-dom";
import style from "./style.module.scss";
import "./headerStyle.scss";
import { rootName } from "../../../utils/constant";
import {
  primaryRoutes,
  publicRouteObj,
  sidebarRouteObj,
} from "../../../staticObjects";
import LogoWhite from "../../Assets/Images/pdfWhite.png";
import Language from "../../Assets/Images/languageIcon.svg";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Ui/button/CommonButton";
import { StoreImages } from "../../Storeimgaes/StoreImages";
import { isAuthenticated } from "../../../redux/selector";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
const Header = () => {

  const {LandingLogo} = StoreImages;
  const { data } = useSelector((state) => state?.user);

  const [menuActive, setMenuActive] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const [language, setLanguage] = useState(null);
  const { t, i18n } = useTranslation();

  const handleLanguageClick = (item) => {
    setLanguage(item);
    i18n.changeLanguage(item);
    localStorage.setItem("language", item);
  };

  useEffect(() => {
    const lang = localStorage.getItem("language");
    document.body.classList.add("en");

    if (lang === "mn") {
      document.body.classList.add("mn");
      document.body.classList.remove("en");
    }
    if (lang === "en") {
      document.body.classList.add("en");
      document.body.classList.remove("mn");
    }
  }, [language]);

  const languageList = [
    { code: "en", label: "English" },
    { code: "mn", label: "монгол" },
  ];
  const isLoggedIn = data && Object.keys(data).length > 0;

  const { ToggleIcon } = StoreImages;
  const navigate = useNavigate();
  const isLoged = useSelector((state) => isAuthenticated(state));
  const [visible, setVisible] = useState(false);

  const [color, setColor] = useState(false);
  const colorChange = () => {
    if (window.scrollY >= 50) {
      setColor(true);
    } else setColor(false);
  };
  window.addEventListener("scroll", colorChange);
  let loginLink = `${rootName}${publicRouteObj.login}`;
  let signupLink = `${rootName}${publicRouteObj.createAccount}`;

  const handleDrawerStateChange = (visible) => {
    const body = document.body;

    if (visible) {
      // document.documentElement.classList.add('drawer-open')
      body.classList.add("drawer-open");
    } else {
      body.classList.remove("drawer-open");
      // document.documentElement.classList.remove('drawer-open')
    }
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("drawer-open");
    };
  }, []);
  return (
      <>
        <header className='header-outer'>
          <div className='container'>
            <div className="header-inner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className='logo head-col position-relative'>
                <Link to='/'>
                  <img src={LandingLogo} alt="imgs" />
                  {/* <img src='/assets/images/inkagent-logo.png' alt="Logo" /> */}
                </Link>
              </div>

              {/* Mobile Menu Icon */}
              <div className='mobile-menu-icon' onClick={toggleMenu}>
                {menuActive ? <MenuCLose /> : <MenuIcon />}
              </div>

              {/* Menu Links */}
              <div className={`header-menu head-col ${menuActive ? 'active' : ''}`}>
                {/*<Link to='/services' className={location.pathname === '/services' ? 'active' : ''}>*/}
                {/*  Services*/}
                {/*</Link>*/}
                <Link to='/pricing-agent' className={location.pathname === '/pricing' ? 'active' : ''}>
                  Pricing
                </Link>
                <Link to='/faq' className={location.pathname === '/faq' ? 'active' : ''}>
                  FAQ
                </Link>
                <Link to='/resources' className={location.pathname === '/resources' ? 'active' : ''}>
                  Resources
                </Link>

                {/* Additional Links for Mobile View */}
                <Link to='/contact-sales' className={location.pathname === '/contact-sales' ? 'active m-hide' : 'm-hide'}>
                  Contact Sales
                </Link>
                <Link to='/login' className={location.pathname === '/login' ? 'active' : 'm-hide'}>
                  Log In
                </Link>
                <Link to="/register" className='custom-btn theme-button m-hide'>
                <span className='d-flex align-items-center justify-content-between w-100'>
                Sign Up
                </span>
                  <span className="icon-circle">
                    <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.41211 9H21.3481" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
                      <path d="M13.9961 1.64893L21.3471 8.99993" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
                      <path d="M21.3477 9L13.9967 16.351" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
                    </svg>
                </span>
                </Link>
              </div>

          <div className='header-right head-col d-flex align-items-center justify-content-end'>
            <Link to='/contact-sales' className={location.pathname === '/contact-sales' ? 'active' : ''}>
              Contact Sales
            </Link>
            <Link to={isLoggedIn ? '/my-account' : '/login'} className={location.pathname === (isLoggedIn ? '/my-account' : '/login') ? 'active' : ''}>
              {isLoggedIn ? 'My Account' : 'Log In'}
            </Link>
            <Link to={isLoggedIn ? '/logout' : '/register'} className='custom-btn theme-button'>
        <span className='d-flex align-items-center justify-content-between w-100'>
          {isLoggedIn ? 'Sign Out' : 'Sign Up'}
        </span>
              <span className="icon-circle">
          <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.41211 9H21.3481" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
            <path d="M13.9961 1.64893L21.3471 8.99993" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
            <path d="M21.3477 9L13.9967 16.351" stroke="white" strokeWidth="2" strokeLinecap="round"></path>
          </svg>
        </span>
            </Link>
          </div>

            </div>
          </div>
        </header>
      </>
  );
};
export default Header;
